import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ROLinkCandidate} from "../types/ROLinkCandidate";

export const useGetROLinkCandidates = (companyID: number, enabled: boolean) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ro-link-candidates', companyID],
        queryFn: async () => await apiClient.get('retail-order/ro-link-candidates',
            {
                params: {
                    companyID: companyID
                }
            }) as ROLinkCandidate[],
        enabled: enabled
    });

    return {
        data,
        isLoading
    };
};
